import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";
import bgImg from "../Assets/Images/house-409451_1280.jpg";

const HomeHero = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const projects = [
    {
      title: "Skyline Residences",
      description: "Urban living redefined",
      image: "/placeholder.svg?height=800&width=600",
    },
    {
      title: "Eco Haven",
      description: "Sustainable luxury in nature",
      image: "/placeholder.svg?height=800&width=600",
    },
    {
      title: "The Prism Tower",
      description: "A landmark of innovation",
      image: "/placeholder.svg?height=800&width=600",
    },
  ];

  return (
    <div className="min-h-screen bg-black text-white flex flex-col justify-center relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={bgImg || "/placeholder.svg"}
          alt="Analog landscape city with buildings"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-secondaryx bg-opacity-98 mix-blend-multiply"></div>
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <h2 className="text-3xl font-light mb-4">Welcome to</h2>
            <h1 className="text-6xl md:text-8xl font-bold mb-6 leading-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-primaryx">
                RamaDreams
              </span>{" "}
              Group
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-2xl">
              Crafting spaces that inspire, innovate, and stand the test of
              time. We blend art, science, and sustainability to create
              architectural marvels.
            </p>
            <div className="flex flex-wrap gap-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-white text-black rounded-full text-lg font-semibold shadow-lg hover:bg-opacity-90 transition duration-300 flex items-center"
              >
                Explore Our Projects
                <ArrowRight className="ml-2" size={20} />
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-transparent border-2 border-white rounded-full text-lg font-semibold shadow-lg hover:bg-secondaryx hover:border-secondaryx hover:text-white transition duration-300 flex items-center"
              >
                Send us a message
              </motion.button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="relative"
          >
            <div className="flex justify-between items-end">
              <div className="max-w-md">
                <AnimatePresence mode="wait">
                  <motion.h3
                    key={`title-${activeIndex}`}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                    className="text-4xl font-bold mb-2"
                  >
                    {projects[activeIndex].title}
                  </motion.h3>
                  <motion.p
                    key={`desc-${activeIndex}`}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="text-xl text-gray-300"
                  >
                    {projects[activeIndex].description}
                  </motion.p>
                </AnimatePresence>
              </div>
              <div className="flex gap-2">
                {projects.map((_, index) => (
                  <motion.button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-3 h-3 rounded-full ${
                      index === activeIndex ? "bg-white" : "bg-gray-500"
                    }`}
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.9 }}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center"
      >
        <p className="text-sm text-gray-400 mb-2">
          Scroll to explore our world
        </p>
        <ChevronDown
          className="mx-auto animate-bounce text-gray-400"
          size={24}
        />
      </motion.div>
    </div>
  );
};

export default HomeHero;
